import React, {Component} from "react";
import PropTypes from "prop-types";

class InputRange extends Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    rangeValue: PropTypes.number,
    min: PropTypes.number,
    step: PropTypes.number,
    onChange: PropTypes.func
  };

  static defaultProps = {
    defaultValue: 40,
    min: 40,
    max: 300,
    step: 20,
    onChange: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      rangeValue: props.defaultValue
    }

    this.onInputRangeChange = this.onInputRangeChange.bind(this);
  }

  onInputRangeChange = (event) => {
    const rangeValue = event.currentTarget.value

    this.setState({
      ...this.state,
      rangeValue: rangeValue
    })
  }

  onMouseUp = () => {
    if(this.props.onChange) {
      const {rangeValue} = this.state
      this.props.onChange(rangeValue)
    }
  }

  render() {
    const {min, step} = this.props
    const {rangeValue} = this.state

    return (
      <div className="slidecontainer">
        {rangeValue}
        <input
          type="range"
          min={min}
          step={step}
          max={300}
          value={this.state.rangeValue}
          onChange={this.onInputRangeChange}
          onMouseUp={this.onMouseUp}
          className="slider" />
      </div>
    )
  }
}

export default InputRange